<template>
    <div :class="$root.isMob && $route.path=='/' ? 'footer home' : 'footer'" :style="$root.isMob && innerWidth < 1200 && $route.path=='/' ? { background: 'url(' + footerBG + ')' } : {}">
      <div class="titleBG"></div>
      <table>
        <thead>
          <tr>
            <td>
              关于我们
            </td>
            <td>
              友情链接
            </td>
            <td>
              联系地址
            </td>
            <td>
              菲泰姆微信公众号欢迎您
            </td>
          </tr>
        </thead>        
      </table>
      <table id="content">
        <tbody>
          <tr>
            <td>
              <div class="footerChild">
                <span><RouterLink to="/about">公司介绍</RouterLink></span><br>
                <span><RouterLink to="/about?type=2">公司荣誉</RouterLink></span><br>  
                <span><RouterLink to="/about?type=3">联系我们</RouterLink></span><br> 
                <span><RouterLink to="/about?type=4">人才招聘</RouterLink></span><br> 
              </div>               
            </td>
            <td>
              <div class="footerChild links">
                <span v-for="item in links" :key="item.id">
                  <a target="_blank" :href="item.url">{{item.title}}</a><br>
                </span>
              </div>
            </td>
            <td>
              <div class="footerChild">
                <span>地址:河南省开封市龙亭区郑开大道与八大街交界三合国际4楼</span><br>
                <span>邮编:475000</span><br>
                <span>邮箱:FEITEM316@163.COM</span><br>
              </div>
            </td>
            <td>
              <div class="footerIMGs">
                <div class="footerIMG">
                  <img src="@/assets/img/service.png" alt=""/>
                  <span>客服二维码</span>
                </div>
                <div class="footerIMG">
                  <img src="@/assets/img/website.png" alt=""/>
                  <span>公司二维码</span>
                </div>
              </div>              
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mobBox">
        <div class="contentBox leftToRight">        
          <span class="textZh">关注我们</span>
          <div class="diagonal-line"></div>
          <span class="textEn">FOLLOW US</span>
        </div> 
        <div class="footerContent">
          <div class="qrcode">
            <img src="@/assets/img/service.png" alt=""/>
            <div class="text">
              客服二维码
            </div>
          </div>
          <div class="qrcode">
            <img src="@/assets/img/website.png" alt=""/>
            <div class="text">
              公司二维码
            </div>
          </div>          
        </div>   
        <div class="text" v-if="isShowTel">
          <div class="row">
            <a href="tel:15101614752">郭经理:15101614752</a>
          </div>
          <div class="row">
            <a href="tel:15837840771">刘经理:15837840771</a>
          </div>
          <div class="row">
            <a href="mailto:feitem316@163.com">Email:feitem316@163.com</a>
          </div>
        </div>     
      </div>
    </div>
</template>

<script>
import footerBG from '@/assets/img/footer.jpg'

export default {
  name: 'FooterPage',
  components: {
  },
  data() {
    return {
      baseUrl:window.config.apiUrl,
      links:[],
      footerBG:footerBG,
      isShowTel:true,
      innerWidth:window.innerWidth
    }
  },
  watch: {
    '$route.path': function() {
      this.toggleTel();
    }
  },
  methods: {    
    async getBaseData() {
      let data = await this.$root.getLinks(2);
      this.links = data.data;
    },
    toggleTel(){
      if(this.$route.path == '/'){
        this.isShowTel = false;
      }
      else{
        this.isShowTel = true;
      }
    }
  },
  created(){
    this.toggleTel();
  },
  mounted() {
    this.getBaseData();
  },
}
</script>

<style lang="scss" src="@/assets/css/footerPage.scss" scoped></style>